export const defaultTableColumns = ["ID", "Motorista", "Responsável", "Filial", "Data de Criação"]

export const financialTableColumns = [...defaultTableColumns, "Status", "Opções"]
